export class SearchOutput {
    count: number;
    incidentId: any;
}


// WEBPACK FOOTER //
// ./src/app/modules/el-data-management/eldm-filters/entities/search-output.ts